import { Ii18nInterpolationObject } from "src/@types/i18next";
import { SVGReactComponent } from "src/@types";
import { IClone } from "./clones";
import { IInquiry } from "./inquiries";
import { IUser } from "src/@types/users";

export enum Statuses {
  NEW_REQUEST = "newRequest",
  PENDING = "pending",
  IN_PROGRESS = "inProgress",
  DONE = "done",
  SUSPENDED = "suspended",
  CANCELED = "canceled",
}

export interface IStatusIndicator {
  className?: string;
  icon: SVGReactComponent;
  title: string | Ii18nInterpolationObject;
}

export interface IDeal {
  id: number;
  clone: IClone;
  inquiry: IInquiry;
  status: Statuses;
  buyer: IUser;
  seller: IUser;
  chat: number;
  is_host: boolean;
}
